import React from 'react';
import { Eye, Edit, Trash2, ChevronLeft, ChevronRight, Briefcase } from 'lucide-react';
import EmptyState from '../Common/EmptyState';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const PositionTable = ({
  positions,
  pagination,
  totalCount,
  onView,
  onEdit,
  onDelete,
  getStatusBadge,
  getLevelBadge,
  onCreate,
}) => {
  const total = totalCount != null ? totalCount : positions?.length ?? 0;
  if (!positions?.length) {
    return (
      <div className="card">
        <div className="card-content py-2">
          <EmptyState
            icon={Briefcase}
            title="Nenhum cargo cadastrado"
            description="Defina cargos para vincular a contatos e estrutura organizacional."
            action={
              onCreate ? (
                <Can permission={P.CONTACT_ACCESS}>
                  <button type="button" className="btn btn-primary" onClick={onCreate}>
                    Novo cargo
                  </button>
                </Can>
              ) : null
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-content p-0">
        <div className="overflow-x-auto">
          <table className="table">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" className="rounded border-gray-300" />
                </th>
                <th>Nome</th>
                <th>Descrição</th>
                <th>Nível</th>
                <th>Status</th>
                <th>Criado em</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {positions.map((position) => (
                <tr key={position.id}>
                  <td>
                    <input type="checkbox" className="rounded border-gray-300" />
                  </td>
                  <td>
                    <div className="font-medium text-gray-900">{position.name}</div>
                  </td>
                  <td>
                    <div className="text-sm text-gray-900 max-w-xs truncate">
                      {position.description}
                    </div>
                  </td>
                  <td>
                    {getLevelBadge(position.level)}
                  </td>
                  <td>
                    {getStatusBadge(position.isActive)}
                  </td>
                  <td>
                    <div className="text-sm text-gray-900">
                      {new Date(position.createdAt).toLocaleDateString('pt-BR')}
                    </div>
                  </td>
                  <td>
                    <Can permission={P.CONTACT_ACCESS}>
                      <div className="flex items-center gap-2">
                        <button
                          type="button"
                          onClick={() => onView(position)}
                          className="btn btn-outline btn-sm btn-icon"
                          title="Visualizar"
                        >
                          <Eye className="w-4 h-4" />
                        </button>
                        <button
                          type="button"
                          onClick={() => onEdit(position)}
                          className="btn btn-outline btn-sm btn-icon"
                          title="Editar"
                        >
                          <Edit className="w-4 h-4" />
                        </button>
                        <button
                          type="button"
                          onClick={() => onDelete(position)}
                          className="btn btn-outline btn-sm btn-icon text-danger-600 hover:text-danger-700 hover:bg-danger-50"
                          title="Excluir"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </Can>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {/* Pagination */}
        <div className="pagination px-6 py-4 border-t border-gray-200">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-600">
              Mostrando {((pagination.page - 1) * pagination.limit) + 1} a {Math.min(pagination.page * pagination.limit, total)} de {total} cargos
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={pagination.prevPage}
                disabled={!pagination.hasPrev}
                className="pagination-btn"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
              
              {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                const page = i + 1;
                return (
                  <button
                    key={page}
                    onClick={() => pagination.goToPage(page)}
                    className={`pagination-btn ${pagination.page === page ? 'active' : ''}`}
                  >
                    {page}
                  </button>
                );
              })}
              
              {pagination.totalPages > 5 && (
                <>
                  <span className="px-2 text-gray-500">...</span>
                  <button
                    onClick={() => pagination.goToPage(pagination.totalPages)}
                    className="pagination-btn"
                  >
                    {pagination.totalPages}
                  </button>
                </>
              )}
              
              <button
                onClick={pagination.nextPage}
                disabled={!pagination.hasNext}
                className="pagination-btn"
              >
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PositionTable;
